import { gql } from '@apollo/client';

export const fetchCloudSitesForOrganization = gql`
  query fetchCloudSitesForOrganization($id: ID!, $editionFilter: Boolean, $transactionAccountId: String) {
    cloudSitesForOrganization(id: $id, editionFilter: $editionFilter, transactionAccountId: $transactionAccountId) {
      cloudSiteId
      cloudSiteHostname
      parentEntitlementId
    }
  }
`;
